import React from "react";

import { useDispatch } from "react-redux";

import * as documentActions from "../../../../../store/actions/documentActions";

const ActionButtonRenderer = (props) => {
    const dispatch = useDispatch();

    const showBinderDetailPage = (Id) => {
        dispatch(documentActions.getBindersDetail(Id));
        dispatch(documentActions.getBindersHistory(Id));
        dispatch(documentActions.showBinderDetailPage(true));
    }

    return (
      <div className="icon-list cursor-pointer">
        <div className="icon-container-list">
          <viedoc-icon
            attribute="nocolor"
            name="arrow"
            onClick={()=>showBinderDetailPage(props.value)}
          />
        </div>
      </div>
    );
  };

  export default ActionButtonRenderer;
